<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>工作台</el-breadcrumb-item>
            <el-breadcrumb-item>客服门店列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="padding: 10px;">
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-select v-model="queryInfo.city" clearable filterable placeholder="请选择城市"  style="margin-right:10px" @change="getList()">
                            <el-option v-for="(item, index) in cityList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-input v-model="queryInfo.query" clearable placeholder="请输入门店名称/门店序号" style="width: 400px;" @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                  <span>
                    在线人数：{{allPeople}}
                  </span>
                </el-col>
            </el-row>
        </div>
        <!-- 加载状态和错误提示 -->
        <el-row v-if="isLoading" style="margin: 20px 0;">
            <el-col :span="24" style="text-align: center;">
                <el-card shadow="never" style="background-color: transparent; border: none;">
                    <div style="padding: 20px;">
                        <i class="el-icon-loading" style="font-size: 30px;"></i>
                        <p>正在加载门店数据...</p>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row v-else-if="loadError" style="margin: 20px 0;">
            <el-col :span="24" style="text-align: center;">
                <el-card shadow="hover">
                    <div style="padding: 20px;">
                        <i class="el-icon-warning-outline" style="font-size: 30px; color: #E6A23C;"></i>
                        <p>{{ errorMessage || '加载数据失败，请稍后再试' }}</p>
                        <el-button type="primary" @click="getList" size="small" style="margin-top: 10px;">重试</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row v-else-if="storeList.length === 0" style="margin: 20px 0;">
            <el-col :span="24" style="text-align: center;">
                <el-card shadow="hover">
                    <div style="padding: 20px;">
                        <i class="el-icon-info" style="font-size: 30px; color: #909399;"></i>
                        <p>暂无门店数据</p>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row v-else :gutter="10" style="height:calc(100vh - 400px);overflow-y: auto;">
            <el-col v-for="(item, index) in storeList" :key="index" :span="6">
                <div style="background: #fff; border-radius: 10px; margin: 10px 5px; position: relative; overflow: hidden;cursor: pointer;" @click="goStoreInfo(item.id)">
                    <!-- 图片容器（相对定位） -->
                    <div style="position: relative;">
                        <img
                        src="@/assets/image/store.jpg"
                        :alt="item.Storename"
                        style="width: 100%; display: block; border-radius: 10px 10px 0 0;"
                        >

                        <!-- 叠加在图片底部的地址（绝对定位） -->
                        <div style="
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        background: rgba(0, 0, 0, 0.3);
                        color: white;
                        padding: 8px 12px;
                        font-size: 13px;
                        backdrop-filter: blur(2px);
                        ">
                        <i class="el-icon-location" style="margin-right: 5px;"></i>
                        {{ item.address || '地址待更新' }}
                        </div>
                    </div>

                    <!-- 数据统计部分（保持不变） -->
                    <div style="padding: 10px; height: 100px;">
                        <div style="display: flex; justify-content: space-around; font-size: 16px;">
                        <div style="text-align: center;">
                            <div style="font-weight: 400;">{{item.member_count || 0}}</div>
                            <div style="color: #999;">会员数量</div>
                        </div>
                        <div style="text-align: center;">
                            <div style="font-weight: 400;">{{item.visitor_in || 0}}</div>
                            <div style="color: #999;">今日客流</div>
                        </div>
                        </div>
                        <div style="text-align: center; font-size: 20px; font-weight: bold; margin-top: 10px;">
                          {{ item.xh }}—{{ item.storename }} ({{item.curPeople}}) <span v-if="item.isopen == 3" style="color: #999;">（ 装修 ）</span>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <!--分页区域-->
        <br>
        <div align="center">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="queryInfo.pagenum" :page-sizes="[8,40,80]"  :page-size="queryInfo.pagesize"
            layout="total, sizes, prev, pager, next" :total="total">
            </el-pagination>
        </div>
        <!--分页区域-->
    </div>
</template>
<script>
    export default {
        data() {
            return{
              allPeople: 0,
                storeList:[], // 将在API请求成功后填充
                queryInfo: {
                    query: '',
                    city:'',
                    pagenum: 1,
                    pagesize: 8
                },
                cityList:[],
                total: 0,
                imgURL:this.GLOBAL.imgURL,
                // 添加默认数据，确保API请求失败时也能显示一些内容
                isLoading: true,
                loadError: false,
                errorMessage: ''
            }
        },
        created(){
            console.log('StoreList组件created钩子执行')
            console.log('当前token状态:', {
                admin_token: window.sessionStorage.getItem('admin_token'),
                login_token: window.sessionStorage.getItem('login_token'),
                join_token: window.sessionStorage.getItem('join_token')
            })
            this.getList()
        },
        methods:{
            async getList(){
                console.log('开始请求stores/ API')
                this.isLoading = true
                this.loadError = false
                this.errorMessage = ''

                try {
                    const { data:res } = await this.$http.get('stores/',{ params: this.queryInfo })
                    console.log('API请求成功:', res)

                    if(res.code == 0){
                        this.storeList = res.data
                        this.total = res.total
                        this.allPeople = res.allPeople
                        // 提取并去重
                        this.cityList = res.cities ? res.cities.map(item => ({
                            value: item,
                            label: item
                        })) : []
                    } else {
                        console.error('API返回错误代码:', res.code, res.msg || res.message)
                        this.loadError = true
                        this.errorMessage = res.msg || res.message || '加载数据失败'
                        // 即使API返回错误，也不要重定向到登录页
                    }
                } catch (error) {
                    console.error('API请求失败:', error)
                    this.loadError = true

                    if (error.response) {
                        console.error('HTTP状态码:', error.response.status)
                        console.error('响应数据:', error.response.data)

                        // 防止重定向到登录页
                        if (error.response.status === 401) {
                            console.log('捕获到401错误，阻止重定向')
                            this.errorMessage = '未登录或登录已过期，但您仍然可以浏览客服门店信息'
                        } else {
                            this.errorMessage = error.response.data?.msg || '加载数据失败'
                        }
                    } else {
                        this.errorMessage = error.message || '网络错误，请检查您的网络连接'
                    }
                } finally {
                    this.isLoading = false
                }
            },
            handleSizeChange(newSize){
                this.queryInfo.pagesize = newSize
                this.getList()
            },
            handleCurrentChange(newPage){
                this.queryInfo.pagenum = newPage
                this.getList()
            },
            goStoreInfo(id){
                this.$router.push({ path: `/customer-store-info/${id}`})
            }
        }
    }
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        /* width: 100%; */
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
    height: 0px;

    }
</style>
